import script from "./PaymentModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./PaymentModal.vue?vue&type=script&setup=true&lang=ts"

import "./PaymentModal.vue?vue&type=style&index=0&id=6ad8650a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ad8650a"]])

export default __exports__